import type { ReactNode, Ref } from 'react'
import { type MotionValue } from 'motion/react'
import { AccessDeniedView } from '@/components/AccessDeniedView'
import { Button } from '@/components/Button'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'
import { ViewHeading } from '@/components/ViewHeading'
import styles from './ClientUserManagement.module.css'

export interface ClientUserManagementProps {
  canAccessClientUserManagement: boolean
  scrollRef: Ref<HTMLDivElement>
  scrollOffset: MotionValue<number>
  canInviteClients?: boolean
  corporateMode: boolean
  onInvite: () => void
  /**
   * The client list and dialogs.
   */
  children: ReactNode
}

export function ClientUserManagement({
  canAccessClientUserManagement,
  scrollRef,
  scrollOffset,
  canInviteClients,
  corporateMode,
  onInvite,
  children,
}: ClientUserManagementProps) {
  return canAccessClientUserManagement ? (
    <div ref={scrollRef} className={styles.root}>
      <StickyViewHeader scrollOffset={scrollOffset} flush>
        <StickyViewHeaderMain>
          <ViewHeading primaryText="Client Management" secondaryText="" />
        </StickyViewHeaderMain>
        {canInviteClients && (
          <StickyViewHeaderExtras>
            <Button
              label="Invite"
              variant="secondary"
              testId="client-management-invite-button"
              onPress={onInvite}
            />
          </StickyViewHeaderExtras>
        )}
      </StickyViewHeader>
      {children}
    </div>
  ) : (
    <AccessDeniedView
      corporateMode={corporateMode}
      testId="user-management-access-denied"
    />
  )
}
